import { BidComparisonSupplierModel } from '@abb-procure/data';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasScores',
})
export class HasScoresPipe implements PipeTransform {
  transform(value: BidComparisonSupplierModel[] | null | undefined): boolean {
    if (!value) {
      return false;
    }

    return value?.some(
      (supplier) => !!supplier.latestQuotation?.requirementsComplianceScores,
    );
  }
}
